export class ApiEndpoints {
  static readonly me = 'me';
  static readonly companies = 'companies';
  static readonly companies_selectable = 'companies_selectable';
  static readonly companyTree = 'companytree';
  static readonly sites = 'sites';
  static readonly site = 'site';
  static readonly company = 'networkcompany';
  static readonly companyEdit = 'company';
  static readonly companyChild = 'children';
  static readonly taxCheck = 'companytax';
  static readonly network = 'network';
  static readonly networks = 'networkfilter';
  static readonly sync = 'sync';
  static readonly mpointFilterData = 'networkfilterdata';
  static readonly image = 'image';
  static readonly users = 'users';
  static readonly user_company = 'usercompany';
  static readonly logs = 'logs';
  static readonly devicelogs = 'devicelogs';
  static readonly measures = 'measures';
  static readonly units = 'units';
  static readonly devicedialog = 'devicedialog';
  static readonly companynetwork = 'companynetwork';
  static readonly devices = 'devices';
  static readonly devicessimple = 'devicessimple';
  static readonly devicefilters = 'devicesfilters';
  static readonly devicefilter = 'devicefilter';
  static readonly deviceTypes = 'devicetypes';
  static readonly deviceType = 'devicetype';
  static readonly deviceAttribute = 'deviceattribute';
  static readonly availableDeviceAttribute = 'availabledeviceattribute';
  static readonly devicetypeConfig = 'devicetypeconfig';
  static readonly device = 'device';
  static readonly deviceOptions = 'deviceoptions';
  static readonly deviceInfo = 'deviceinfo';
  static readonly deviceInfoList = 'deviceinfolist';
  static readonly node = 'node';
  static readonly yml = 'yml';
  static readonly datapoint = 'datapoint';
  static readonly ping = 'ping';
  static readonly query = 'mosbusquery';
  static readonly write = 'write';
  static readonly writemultiple = 'writemultiple';
  static readonly writemeasure = 'writemeasure';
  static readonly modbusrtu = 'modbusrtu';
  static readonly modbusrtudata = 'modbusrtudata';
  static readonly modbusrtuMeasures = 'modbusrtumeasures';
  static readonly deviceChildren = 'devicechildren';
  static readonly deviceChildrenWithInfo = 'devicechildrenwithinfo';
  static readonly postattribute = 'postattribute';
  static readonly influx = 'influx';
  static readonly status3f = 'status3f';
  static readonly interface = 'interface';
  static readonly counters = 'rawcounters';
  static readonly counter = 'rawcounter';
  static readonly sync15minDevices = 'sync15mindevices';
  static readonly resetCounter = 'resetcounter';
}
